import Config from './index'

const apiUrl = Config.baseURL.replace('http', 'ws')

const SOCKETAPI = {
  invite: `${apiUrl}ws/game/controller/`,
  match: `${apiUrl}ws/game/match/controller/`
}

export default SOCKETAPI
